import { render } from "./SafetyPolicies.vue?vue&type=template&id=ee8f78d6"
import script from "./SafetyPolicies.vue?vue&type=script&lang=js"
export * from "./SafetyPolicies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__